import { render, staticRenderFns } from "./SchoolAdd.vue?vue&type=template&id=13faafce&scoped=true&"
import script from "./SchoolAdd.vue?vue&type=script&lang=js&"
export * from "./SchoolAdd.vue?vue&type=script&lang=js&"
import style0 from "./SchoolAdd.vue?vue&type=style&index=0&id=13faafce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13faafce",
  null
  
)

export default component.exports